export const httpRequestTypes = ['get', 'put', 'post', 'delete'];
